import { render, staticRenderFns } from "./MyProduct.vue?vue&type=template&id=218f0966&scoped=true&"
import script from "./MyProduct.vue?vue&type=script&lang=ts&"
export * from "./MyProduct.vue?vue&type=script&lang=ts&"
import style0 from "./MyProduct.vue?vue&type=style&index=0&id=218f0966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f0966",
  null
  
)

export default component.exports